import { format, isThisYear, isToday, isYesterday } from 'date-fns';

const DATE_FORMAT_SHORT = 'MMM do'; // e.g., "Jan 15th"
const DATE_FORMAT_WITH_YEAR = 'MMM do, yyyy'; // e.g., "Jan 15th, 2024"

/**
 * Formats the latest message timestamp to a human-readable date string for ConversationItem display.
 *
 * @param messageDateMs - The latest message date as a timestamp string (milliseconds since epoch)
 * @returns Formatted date string:
 *   - "Today" if the message is from today
 *   - "Yesterday" if the message is from yesterday
 *   - "Jan 15th" if the message is from this year
 *   - "Jan 15th, 2024" if the message is from a previous year
 *   - Empty string if no date is provided
 */
export default function getLatestMessageDateText(messageDateMs = ''): string {
  if (!messageDateMs) {
    return '';
  }

  const timestamp = Number(messageDateMs);
  const date = new Date(timestamp);

  if (isToday(date)) {
    return 'Today';
  }

  if (isYesterday(date)) {
    return 'Yesterday';
  }

  const formatToken = isThisYear(date) ? DATE_FORMAT_SHORT : DATE_FORMAT_WITH_YEAR;
  return format(date, formatToken);
}
